import { createFileRoute } from "@tanstack/react-router";
import { KnowledgeBaseView } from "@/components/tabs/KnowledgeBase";

export const Route = createFileRoute("/knowledge/")({
  component: KnowledgeBaseView,
});
